import { Component } from '@angular/core';

@Component({
  selector: 'app-application-configuration',
  templateUrl: './application-configuration.component.html',
  styleUrls: ['./application-configuration.component.scss']
})
export class ApplicationConfigurationComponent {

}
